import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { AuthService } from '../../../services/auth.service'
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router'
import { DeviceDetectorService } from 'ngx-device-detector'
import { RouteParamsService } from '../../../services/route-params.service'
import { NavbarMainComponent } from '../navbar-main/navbar-main.component';
import { NavbarChantierComponent } from '../navbar-chantier/navbar-chantier.component';
import { NavbarSecondaryMenuComponent } from '../navbar-secondary-menu/navbar-secondary-menu.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'lg-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    imports: [
        NavbarMainComponent,
        NavbarChantierComponent,
        NavbarSecondaryMenuComponent,
        RouterOutlet,
        FooterComponent,
    ],
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService)
  private router = inject(Router)
  private activatedRoute = inject(ActivatedRoute)
  private renderer = inject(Renderer2)
  deviceService = inject(DeviceDetectorService)
  private routeParamsService = inject(RouteParamsService)

  chantierCode: string

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'app-layout')

    this.routeParamsService.chantierCode.subscribe((chantierCode) => {
      this.chantierCode = chantierCode
    })
  }

  navigateToRightPage() {
    if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
      if (this.router.url.includes('/a-receptionner')) {
        this.router.navigate(['/chantiers', this.chantierCode, 'sur-chantier'])
      } else if (this.router.url.includes('/sur-chantier')) {
        this.router.navigate(['/chantiers', this.chantierCode, 'historique'])
      }
    }
  }

  navigateToLeftPage() {
    if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
      if (this.router.url.includes('/historique')) {
        this.router.navigate(['/chantiers', this.chantierCode, 'sur-chantier'])
      } else if (this.router.url.includes('/sur-chantier')) {
        this.router.navigate(['/chantiers', this.chantierCode, 'a-receptionner'])
      }
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'app-layout')
  }
}
